import React from "react";
import imagen from "../images/imagen.jpg";

const Acerca = ({id}) => {
  return (
    <div
      id={id}
      className="lg:h-screen h-full justify-center flex items-center w-full bg-slate-800"
    >
      <div className="xl:w-8/12   lg:w-10/12   m-auto">
        <div className="flex">
          <div className="flex w-full justify-center flex items-center text-gray-300">
            <h4 className="text-emerald-300 sm:text-xl text-lg md:text-2xl mt-0.5">
              01.
            </h4>
            <h4 className="text-gray-300   font-bold ml-3 text-xl sm:text-2xl md:text-3xl">
              Quien soy
            </h4>
            <div className="mr-12"></div>
            <div className="border w-4/12 flex sm:w-6/12 md:w-8/12 h-0 "></div>
          </div>
        </div>
        <div className="sm:flex">
          <div className="text-gray-400   sm:w-7/12 mr-8 mt-6">
            <h4 className="mt-2">
              ¡Hola! Mi nombre es Yeremi y disfruto programar desde
              <a
                target="_blank"
                href="https://github.com/Yeremi528"
                className="text-emerald-300  ml-2"
              >
                sitios web hasta aplicaciones móviles.
              </a>{" "}
              Mi interés por el desarrollo empezó desde muy pequeño pasándome
              arreglando computadores de conocidos hasta solucionar problemas
              con aplicaciones de kali y linux, donde empece a desarrollar mis
              primeros pasos como desarrollador hasta ahora donde me enfoco en
              el crear soluciones y aplicaciones FullStack.
            </h4>
            <div className="sm:flex hidden">
              <div>
                <h4 className="mt-4  text-lg text-gray-300 font-semibold hover:underline">
                  Donde desarrolle mis conocimientos
                </h4>
                <h4 className="mt-2">
                  Empece viendo contenido del{" "}
                  <a
                    className="text-emerald-300 ml-1 mr-1"
                    href="https://ocw.mit.edu/"
                    target="_blank"
                  >
                    MIT(Massachusetts Institute of Technology)
                  </a>
                  que tiene disponible en su página OpenCourse.Decidí empezar a
                  aprender a programar con cursos de{" "}
                  <a
                    target="_blank"
                    className="text-emerald-300"
                    href="https://www.edx.org/es"
                  >
                    EDX
                  </a>
                  , videos de YouTube, libros, y cursos de{" "}
                  <a
                    className="text-emerald-300"
                    target="_blank"
                    href="https://www.udemy.com/"
                  >
                    Udemy
                  </a>
                  .{" "}
                </h4>
                <h4 className="mt-4  text-lg font-semibold hover:underline text-gray-300">
                  Que me inspiro
                </h4>
                <h4 className="mt-2">
                  Mi principal inspiracion para iniciar en el camino del
                  autodidacta fue un libro de{" "}
                  <a
                    target="_blank"
                    className="text-emerald-300 mr-1"
                    href="https://www.scotthyoung.com/"
                  >
                    Scott H.Young
                  </a>
                  con su libro ultralearning en el cual habla de metodos y
                  tecnicas para adquirir conocimiento a una velocidad muy
                  elevada.
                </h4>
              </div>
            </div>
          </div>
          <div className="w-6/12 justify-center m-auto items-center  sm:w-5/12">
            <img
              src={imagen}
              alt="Yo"
              className=" grayscale  hover:grayscale-0 delay-150  duration-300 motion-safe:hover:scale-110 rounded-3xl mt-8 h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Acerca;
